import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LoginFormTW } from '../../components/auth/LoginFormTW';
import { useAuth } from '../../contexts/AuthContext';
import { useLenis } from '../../hooks/useLenis';

export const LoginPageTW: React.FC = () => {
  useLenis(); // Smooth scrolling aktivieren

  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, isLoading } = useAuth();

  // Get redirect path from URL params or state
  const redirectTo = new URLSearchParams(location.search).get('redirect') ||
                     location.state?.from?.pathname ||
                     '/dashboard';

  // Bereits eingeloggte User direkt weiterleiten (z.B. nach Refresh oder
  // wenn jemand /login mit gueltiger Session aufruft).
  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate(redirectTo, { replace: true });
    }
  }, [isAuthenticated, isLoading, navigate, redirectTo]);

  const handleLoginSuccess = () => {
    navigate(redirectTo, { replace: true });
  };

  // Waehrend Auth-Check oder unmittelbar nach erkanntem Login nichts rendern,
  // damit das Formular nicht kurz aufblitzt, bevor der Redirect feuert.
  if (isLoading || isAuthenticated) {
    return null;
  }

  return (
    <LoginFormTW
      onSwitchToRegister={() => navigate('/register')}
      onLoginSuccess={handleLoginSuccess}
    />
  );
};
